import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Input, InputLabel, TextArea } from '../../styled-components';
import { actions as axisOrderActions } from '../../actions/axisOrder';
import { localizeAxis as localize } from '../../util/localizeUtils';

const invalidInputStyle = {
  border: '2px solid red'
};

const Container = styled.div`
  background-color: white;
  padding: 0.25rem 0.75rem;
`;

const DescriptionTextArea = styled(TextArea) `
  font-family: Courier New;
  font-size: 12px;
  height: 3.5rem;
  resize: none;
`;

const CloseButton = styled.button`
  float: right;
  margin-right: -.65rem;
`;

const ButtonContainer = styled.div`
  text-align: right;
`;

const AddItemButton = styled(Button) `
  margin-top: .21rem;
  text-align: center;
`;

class EditItem extends Component {
  render() {
    let titleStyle = {};
    let descriptionStyle = {};

    if (this.props.highlightErrors) {
      if (!this.props.title) {
        titleStyle = invalidInputStyle;
      }

      if (!this.props.description) {
        descriptionStyle = invalidInputStyle;
      }
    }
    return (
      <Container>
        <CloseButton onClick={this.props.onCloseEditItem}>&times;</CloseButton>
        <div style={{ paddingBottom: '0.275rem' }}>
          <InputLabel>{localize('itemTitleLabel')}</InputLabel>
          <Input
            style={titleStyle}
            height="1.5rem"
            width="100%"
            value={this.props.title}
            onChange={(event) => this.props.onChangeTitle(event.target.value)}
            required
          />
        </div>
        <div>
          <InputLabel>{localize('itemDescriptionLabel')}</InputLabel>
          <DescriptionTextArea
            style={descriptionStyle}
            width="100%"
            value={this.props.description}
            onChange={(event) => this.props.onChangeDescription(event.target.value)}
            required
          />
        </div>
        <ButtonContainer>
          <AddItemButton
            padding=".375rem 1.85rem"
            disabled={!this.props.title || !this.props.description}
            onClick={this.props.isEditMode ? this.props.onSaveItem : this.props.onAddItem}
          >
            {this.props.isEditMode ? localize('saveItemButton') : localize('addItemButton')}
          </AddItemButton>
        </ButtonContainer>
      </Container>
    );
  }
}

EditItem.defaultProps = {
  description: '',
  title: ''
};

EditItem.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  highlightErrors: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  onAddItem: PropTypes.func.isRequired,
  onChangeDescription: PropTypes.func.isRequired,
  onChangeTitle: PropTypes.func.isRequired,
  onCloseEditItem: PropTypes.func.isRequired,
  onSaveItem: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  description: state.axisOrder.currentItem.description,
  isEditMode: state.axisOrder.items.some(i =>
    i.replaceableId === state.axisOrder.currentItem.replaceableId),
  title: state.axisOrder.currentItem.title
});

const mapDispatchToProps = {
  onAddItem: axisOrderActions.addItem,
  onChangeDescription: axisOrderActions.changeItemDescription,
  onChangeTitle: axisOrderActions.changeItemTitle,
  onCloseEditItem: axisOrderActions.closeEditItem,
  onSaveItem: axisOrderActions.saveItem
};

export default connect(mapStateToProps, mapDispatchToProps)(EditItem);



// WEBPACK FOOTER //
// ./app/components/OrderForm/EditItem.js